import { RestSlice } from '../../../../../redux/rest.slice';
import { AuthorityTag } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const settingLookupsTagSlice = new RestSlice<AuthorityTag>(
	localizationService.getLocalizedString('cccSettings.lookupTags'),
	Resource.SettingLookup + '/Tags'
);
export default settingLookupsTagSlice.rests.reducer;
